import * as React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  ariaTitle: PropTypes.string
};

/**
 * Component that renders the Credera logo
 * Generated using SVGR CLI -> https://react-svgr.com/docs/cli/
 *
 * @component
 * @param {object} props
 */
const SvgCrederaLogoName = props => {
  const { ariaTitle = 'Credera Logo', height = '' } = props;

  return (
    <svg style={{height: height}} viewBox="0 0 198 33" fill="none" aria-labelledby="credera-logo-light-title">
      <title id="credera-logo-name-title">{ariaTitle}</title>
      <path
        d="M53 16.644c0-4.622 3.449-7.998 7.778-7.998 2.641 0 4.696 1.101 6.09 2.935l-1.1.808c-1.175-1.541-2.789-2.422-4.917-2.422-3.595 0-6.237 2.862-6.237 6.677 0 3.816 2.715 6.678 6.384 6.678 2.201 0 4.036-.954 5.21-2.569l1.174.808c-1.541 2.054-3.67 3.155-6.458 3.155C56.45 24.642 53 21.267 53 16.644zM78.902 24.496h-1.467V8.793h4.622c3.302 0 5.136 2.055 5.136 4.697 0 2.127-1.174 3.742-3.301 4.329l4.035 6.603H86.24l-3.89-6.383h-3.448v6.457zm3.008-7.705c2.495 0 3.67-1.247 3.67-3.302 0-2.054-1.175-3.375-3.67-3.375h-3.008v6.677h3.008zM97.832 8.793h9.246v1.321H99.3v5.797h6.971v1.32H99.3v5.87h8.145v1.395h-9.612V8.793zM117.717 8.793h3.889c5.136 0 8.145 3.229 8.145 7.852 0 4.622-3.009 7.85-8.145 7.85h-3.889V8.794zm3.742 14.309c4.549 0 6.751-2.642 6.751-6.457 0-3.816-2.202-6.457-6.751-6.457h-2.274v12.914h2.274zM140.023 8.793h9.318v1.321h-7.851v5.797h7.044v1.32h-7.044v5.87h8.145v1.395h-9.612V8.793zM161.449 24.496h-1.467V8.793h4.622c3.302 0 5.137 2.055 5.137 4.697 0 2.127-1.174 3.742-3.302 4.329l4.035 6.603h-1.687l-3.889-6.383h-3.449v6.457zm3.009-7.705c2.494 0 3.668-1.247 3.668-3.302 0-2.054-1.174-3.375-3.668-3.375h-3.009v6.677h3.009zM189.845 20.607h-6.97l-1.541 3.889h-1.468L186.323 8.5h.147L193 24.496h-1.541l-1.614-3.89zm-6.383-1.32h5.87l-2.935-7.412-2.935 7.411z"
        fill="#3A3A3A"
      />
      <path fill="#CFCFCF" d="M24 24h9v9h-9z" />
      <path d="M0 0h33v21h-9V9H9v15h12v9H0V0z" fill="#E55F4C" />
    </svg>
  );
};

SvgCrederaLogoName.propTypes = propTypes;

export default SvgCrederaLogoName;
